module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2020-04-23 at 10.00.40 (1).22dc1354.jpeg";